import type { IModule } from '@audacy-clients/core/atoms/wrappers/modules';
import { useTrackModuleView } from 'web/src/hooks/useTrackModuleView';

interface IModuleBannerAdWrapperProps {
  moduleId: IModule['id'];
  contentId: IModule['config']['contentId'];
  children: JSX.Element;
}

const ModuleBannerAdWrapper = ({
  children,
  moduleId,
  contentId,
}: IModuleBannerAdWrapperProps): JSX.Element => {
  const moduleRef = useTrackModuleView({
    moduleId,
    contentId,
  });

  return <div ref={moduleRef}>{children}</div>;
};

export default ModuleBannerAdWrapper;
